import useScorecardStates from './useScorecardStates';

export default function useCanAddScorecardItems() {
  const { isFeedbackCollected, isCompleted } = useScorecardStates();

  return !(isFeedbackCollected || isCompleted);
}
